var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wrapper-interactions"},_vm._l((_vm.getChartsOrderByChannel),function(chart,index){return _c('div',{key:index},[_c(chart.component,{tag:"component"})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }